<template>
  <div>
    <template v-if="loading">
      <div class="card">
        <div
          v-if="loading"
          class="card-body d-flex align-items-center justify-content-center"
          style="height: calc(100vh - 144px)"
        >
          <div class="text-center text-primary my-2 loader">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </div>
      </div>
    </template>
    <template v-if="!loading">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <!-- Start Title -->
              <h4 class="card-title">
                {{ detail.name.toUpperCase() }}
              </h4>
              <!-- Card Title -->
              <!-- End Title -->
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <form
                @submit.prevent="onSubmit"
                novalidate
                enctype="multipart/form-data"
                :class="
                  submitted
                    ? 'needs-validation was-validated'
                    : 'needs-validation'
                "
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value="DZdEYxUPT2VHc5ZcJYfl4a1Mx0j7o6liciskdv6QxfkIQAqi9h3UBGxDwerRS5yu"
                />

                <p></p>
                <h5 class="font-size-14">GENERAL</h5>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="job_title">Title*</label>
                    <v-select
                      v-model.trim="$v.person_title.$model"
                      :options="titleList"
                    ></v-select>
                    <div
                      v-if="submitted && !$v.person_title.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <label for="first_name_id">First Name*</label>
                    <input
                      type="text"
                      name="first_name"
                      id="first_name_id"
                      class="form-control"
                      maxlength="255"
                      required=""
                      v-model.trim="$v.first_name.$model"
                    />
                    <div
                      v-if="submitted && !$v.first_name.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="last_name_id">Last Name*</label>
                    <input
                      type="text"
                      name="last_name"
                      id="last_name_id"
                      class="form-control"
                      maxlength="255"
                      required=""
                      v-model.trim="$v.last_name.$model"
                    />
                    <div
                      v-if="submitted && !$v.last_name.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <label for="middle_name_id">Middle Name</label>
                    <input
                      type="text"
                      name="middle_name"
                      id="middle_name_id"
                      class="form-control"
                      maxlength="255"
                      v-model.trim="middle_name"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="gender_id">Gender</label>
                    <select
                      name="gender"
                      id="gender_id"
                      class="form-select"
                      v-model.trim="gender"
                    >
                      <option value="male" selected="">Male</option>

                      <option value="female">Female</option>
                    </select>
                  </div>

                  <div class="col-lg-6">
                    <label for="date_of_birth_id">Date of Birth</label>
                    <input
                      type="date"
                      name="date_of_birth"
                      id="date_of_birth_id"
                      class="form-control"
                      v-model.trim="date_of_birth"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="address_id">Address</label>
                    <input
                      type="text"
                      name="address"
                      id="address_id"
                      v-model.trim="address"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-6">
                    <label for="personal_mobile">Personal Mobile</label>
                    <input
                      type="text"
                      name="personal_mobile"
                      id="personal_mobile"
                      v-model.trim="$v.personal_mobile.$model"
                      class="form-control"
                      placeholder="999-999-9999"
                      v-mask="'###-###-####'"
                    />
                    <div
                      v-if="
                        submitted && !$v.personal_mobile.customPhoneValidate
                      "
                      class="invalid-tooltip"
                    >
                      You should provide a phone number (###-###-####)
                    </div>
                  </div>

                  <!-- <div class="col-lg-6">
                  <div class="row">

                    <div class="col-12 col-lg-4">
                      <label for="ext">Ext</label>
                      <input
                        type="text"
                        name="ext"
                        id="ext"
                        class="form-control"
                        v-model.trim="ext"
                      />
                    </div>
                  </div>
                </div> -->
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="personal_email">Personal Email</label>
                    <input
                      type="text"
                      name="personal_email"
                      id="personal_email"
                      v-model.trim="personal_email"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-6">
                    <label for="linkedin_url">LinkedIn URL</label>
                    <input
                      type="text"
                      name="linkedin_url"
                      id="linkedin_url"
                      v-model.trim="$v.linkedin_url.$model"
                      class="form-control"
                    />
                    <div
                      v-if="submitted && !$v.linkedin_url.url"
                      class="invalid-tooltip"
                    >
                      You should provide a valid url.
                    </div>
                  </div>
                </div>
                <p></p>

                <h5 class="font-size-14 mt-5">ORGANIZATION</h5>
                <p></p>

                <div class="row">
                  <div class="col-lg-8">
                    <label for="organization_id">Organization*</label>
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      :value="detail.name.toUpperCase()"
                    />
                  </div>
                  <div class="col-lg-4">
                    <label for="job_title_id">Job Title</label>
                    <input
                      type="text"
                      name="job_title"
                      id="job_title_id"
                      class="form-control"
                      maxlength="255"
                      v-model.trim="$v.job_title.$model"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-12 col-lg-4">
                    <label for="email_id">Work Email</label>
                    <input
                      type="text"
                      name="email"
                      id="email_id"
                      v-model.trim="email"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="mobile_phone">Work Mobile Phone</label>
                    <input
                      type="text"
                      name="mobile_phone"
                      id="mobile_phone"
                      v-model.trim="$v.mobile_phone.$model"
                      class="form-control"
                      placeholder="999-999-9999"
                      v-mask="'###-###-####'"
                    />
                    <div
                      v-if="submitted && !$v.mobile_phone.customPhoneValidate"
                      class="invalid-tooltip"
                    >
                      You should provide a phone number (###-###-####)
                    </div>
                  </div>

                  <div class="col-12 col-lg-4">
                    <label for="office_phone">Work Office Phone</label>
                    <input
                      type="text"
                      name="office_phone"
                      id="office_phone"
                      v-model.trim="$v.office_phone.$model"
                      class="form-control"
                      placeholder="999-999-9999"
                      v-mask="'###-###-####'"
                    />
                    <div
                      v-if="submitted && !$v.office_phone.customPhoneValidate"
                      class="invalid-tooltip"
                    >
                      You should provide a phone number (###-###-####)
                    </div>
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-4">
                    <label for="ice_handle">ICE Handle</label>
                    <input
                      type="text"
                      name="ice_handle"
                      id="ice_handle"
                      v-model.trim="ice_handle"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="teams_handle">Teams Handle</label>
                    <input
                      type="text"
                      name="teams_handle"
                      id="teams_handle"
                      v-model.trim="teams_handle"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="Salutation">Salutation</label>
                    <input
                      type="text"
                      name="salutation"
                      id="Salutation"
                      v-model.trim="salutation"
                      class="form-control"
                    />
                  </div>
                </div>
                <p></p>

                <h5 class="font-size-14 mt-5">CONTACT PREFERENCES</h5>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="job_title_id"
                      >Preferred Time of Day for Calls</label
                    >
                    <input
                      type="text"
                      name="job_title"
                      id="job_title_id"
                      class="form-control"
                      v-model.trim="prefered_time_of_day_calls"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label for="prefered_time_of_day_emails"
                      >Preferred Time of Day for Emails</label
                    >
                    <input
                      type="text"
                      name="prefered_time_of_day_emails"
                      id="prefered_time_of_day_emails"
                      class="form-control"
                      v-model.trim="prefered_time_of_day_emails"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="prefered_day_of_week_calls"
                      >Preferred Day of Week for Calls</label
                    >
                    <input
                      type="text"
                      name="prefered_day_of_week_calls"
                      id="prefered_day_of_week_calls"
                      class="form-control"
                      v-model.trim="prefered_day_of_week_calls"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label for="prefered_day_of_week_emails"
                      >Preferred Day of Week for Emails</label
                    >
                    <input
                      type="text"
                      name="prefered_day_of_week_emails"
                      id="prefered_day_of_week_emails"
                      class="form-control"
                      v-model.trim="prefered_day_of_week_emails"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="prefered_checkin_frequency"
                      >Preferred Check-in Frequency</label
                    >
                    <input
                      type="text"
                      name="prefered_checkin_frequency"
                      id="prefered_checkin_frequency"
                      class="form-control"
                      v-model.trim="prefered_checkin_frequency"
                    />
                  </div>
                </div>
                <p></p>

                <div class="d-flex flex-wrap gap-2">
                  <button
                    class="btn btn-success"
                    :disabled="loading"
                    type="submit"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    class="btn btn-light waves-effect"
                    @click="$router.go(-1)"
                  >
                    Cancel
                  </button>
                </div>
                <!-- End Button -->
              </form>
              <!-- End Form -->
            </div>
            <!-- End Card Body -->
          </div>
          <!-- End Card -->
        </div>
        <!-- End Col -->
      </div>
    </template>
  </div>
</template>

<script>
import { organizationsService } from '../services/organizations.service'
import { contactsService } from '../services/contacts.service'
import { required, email, url } from 'vuelidate/lib/validators'
import { customPhoneValidate } from '../helpers'

export default {
  name: 'CreateContactFromOrg',
  components: {},
  data () {
    return {
      titleList: [
        { label: '---------', code: '' },
        { label: 'Dr', code: 'doctor' },
        { label: 'Mr', code: 'mr' },
        { label: 'Ms', code: 'ms' },
        { label: 'Mrs', code: 'mrs' },
        { label: 'Miss', code: 'miss' },
        { label: 'Professor', code: 'professor' },
        { label: 'Sir', code: 'sir' }
      ],
      organizationList: [],
      organization: '',
      first_name: '',
      last_name: '',
      middle_name: '',
      person_title: '',
      department: '',
      address: '',
      mobile_phone: '',
      mobile_phone_raw: '',
      office_phone: '',
      office_phone_raw: '',
      personal_mobile: '',
      personal_mobile_raw: '',
      email: '',
      date_of_birth: '',
      ice_handle: '',
      teams_handle: '',
      linkedin_url: '',
      salutation: '',
      prefered_time_of_day_calls: '',
      prefered_time_of_day_emails: '',
      prefered_day_of_week_calls: '',
      prefered_day_of_week_emails: '',
      prefered_checkin_frequency: '',
      ext: '',
      job_title: '',
      gender: 'male',
      personal_email: '',
      submitted: false,
      loading: true,
      error: '',
      detail: {}
    }
  },
  validations: {
    person_title: { required },
    first_name: { required },
    last_name: { required },
    email: { email },
    personal_email: { email },
    organization: {},
    job_title: {},
    linkedin_url: { url },
    personal_mobile: { customPhoneValidate },
    mobile_phone: { customPhoneValidate },
    office_phone: { customPhoneValidate }
  },
  computed: {},
  created () {
    organizationsService.getDataById(this.$route.params.id).then((_rs) => {
      this.detail = _rs
      this.loading = false
      this.organization = []
      this.organization.push({
        ..._rs,
        code: _rs.organization_id
      })
    })
  },
  methods: {
    updatePhoneMobile (event) {
      this.mobile_phone_raw = event
    },
    updatePhoneOffice (event) {
      this.office_phone_raw = event
    },
    updatePhone (event) {
      this.personal_mobile_raw = event
    },
    onSubmit () {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      //
      this.loading = true
      let payload = {
        first_name: this.first_name,
        last_name: this.last_name,
        middle_name: this.middle_name,
        title: this.person_title.code,
        personal_address: this.address,
        personal_email: this.personal_email,
        linkedin_url: this.linkedin_url,
        personal_mobile: this.personal_mobile,
        gender: this.gender
      }

      if (this.date_of_birth) {
        payload.date_of_birth = this.date_of_birth
      }

      payload = Object.fromEntries(
        Object.entries(payload).filter(([_, v]) => v != null && v !== '')
      )
      contactsService.add(payload).then(
        (rs) => {
          if (this.organization.length === 0 || this.organization === '') {
            this.$bvToast.toast('Add successfully.', {
              title: `Update`,
              variant: 'primary',
              solid: true
            })
            this.$nextTick(() => {
              this.$router.go(-1)
            })
            return
          }

          Promise.all(
            this.organization.map((org) => {
              return contactsService
                .addOrgToContact({
                  contact: rs.contact_id,
                  employment_status: 'active',
                  mobile_phone: this.mobile_phone,
                  job_title: this.job_title,
                  email: this.email,
                  office_phone: this.office_phone,
                  department: this.department,
                  ice_handle: this.ice_handle,
                  teams_handle: this.teams_handle,
                  salutation: this.salutation,
                  prefered_time_day_calls: this.prefered_time_of_day_calls,
                  prefered_time_day_emails: this.prefered_time_of_day_emails,
                  prefered_time_week_day_calls: this.prefered_day_of_week_calls,
                  prefered_time_week_day_emails:
                    this.prefered_day_of_week_emails,
                  prefered_checkin_frequency: this.prefered_checkin_frequency,
                  organization: org.code
                })
                .then((data) => {
                  return data
                })
            })
          )
            .then((values) => {
              this.$bvToast.toast('Add successfully.', {
                title: `Update`,
                variant: 'primary',
                solid: true
              })
              this.$nextTick(() => {
                this.$router.go(-1)
              })
            })
            .catch((e) => {
              this.$bvToast.toast('Error.', {
                title: `Error`,
                variant: 'danger',
                solid: true
              })
              this.loadingAction = false
            })
        },
        (error) => {
          this.error = error
          this.$bvToast.toast('Error.', {
            title: `Error`,
            variant: 'danger',
            solid: true
          })
          this.loading = false
          this.loadingAction = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CreateContactFromOrg.vue